import { Error429Form } from '@features/error/components';
import NoindexHelmet from '@src/components/NoindexHelmet';

function Error429() {
  return (
    <>
      <NoindexHelmet />
      <Error429Form />
    </>
  );
}

export default Error429;
